/**
 * GL206-3, glasronde 0.9.206: "Gestopt: je drukte op Stop" stond in het Nederlands met de app op Engels.
 *
 * De dienst slaat de stopzin op als het antwoord (`backend/services/beurtstop.py::GESTOPT`), zodat hij
 * ook na herladen staat. Een opgeslagen bericht wordt niet herschreven; deze zin is van ONS en niet
 * van het model, dus hij wordt BIJ HET TEKENEN vertaald, zoals de woorden van het bronblok
 * (`bronwoorden.js`). Zo volgt hij de app, ook bij een gesprek van gisteren.
 */

/** Letterlijk gelijk aan `beurtstop.GESTOPT`; een toets houdt de twee gelijk. */
export const GESTOPT = "Gestopt: je drukte op Stop. Er is geen antwoord afgemaakt.";

const VASTE_ZINNEN = [GESTOPT];

/** Het bericht in de taal van `t` als het een vaste zin van de dienst is, anders ongewijzigd. PUUR, op `t` na. */
export function vasteZin(t, inhoud) {
  const tekst = (inhoud || "").trim();
  return VASTE_ZINNEN.includes(tekst) ? t(tekst) : inhoud;
}
